<template>
  <div class="hr-bill">
    <!-- tab切换 -->
    <div class="hr-bill-top">
      <div class="switch-menu">
        <el-radio-group
          class="menu-name"
          v-for="(item, index) in menuList"
          :key="index"
          v-model="selectedTab"
          @change="toUrl(item.url)"
        >
          <el-radio-button :label="item.name"></el-radio-button>
        </el-radio-group>
      </div>
    </div>

    <!-- 列表搜索 -->
    <div class="search search-month-bill">
      <el-form
        ref="searchForm"
        :model="search"
      >
        <div class="search-row">
          <el-form-item label="日期：">
            <el-date-picker
              v-if="search.select === 1"
              v-model="search.date"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
            >
            </el-date-picker>
            <el-date-picker
              v-if="search.select === 2"
              v-model="search.month"
              type="month"
              format="yyyy-MM"
              value-format="yyyy-MM"
              placeholder="选择日期"
            >
            </el-date-picker>
          </el-form-item>
          <div class="btn-operation">
            <el-button icon="el-icon-search" class="btn-blue" @click="searchList">搜索</el-button>
            <el-button icon="el-icon-refresh" class="btn-gray" @click="resetForm('searchForm')">重置</el-button>
          </div>
        </div>
      </el-form>
      
      <div class="btn-container">
        <div class="upload-warehouse" @click="openExportDetailsExcel">
          <span class="upload-warehouse-img"></span>
          <span>账单明细导出</span>
        </div>
      </div>
    </div>

    <div class="hr-bill-container">
      <div class="table" v-if="tableData.length">
        <el-table 
          :data="tableData" 
          style="width: 100%" 
          @selection-change="handleSelectionChange"
          :header-cell-class-name="headerCellClassName"
        >
          <el-table-column type="selection" width="50"></el-table-column>
          <el-table-column
            v-for="(item, index) in tableTitleList"
            :key="index+1"
            :prop="item.prop"
            :label="item.label"
            show-overflow-tooltip
            :min-width="item.width"
            :class-name="item.alignment === 'right'?`cell-right-align-width`:''"
          >
            <template slot-scope="scope">
              <div v-if="item.prop === 'statusVal'" :class="`status${scope.row.status}`">{{ scope.row.statusVal }}</div>
              <div v-else>{{ scope.row[item.prop] }}</div>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="150"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                :class="scope.row.status == 1?'btn-text':'btn-text-gray'"
                :disabled="scope.row.status == 2"
                @click="batchVerification(scope.row.id)"
              >核实</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <pagination-tpl
            :total="total"
            :currentPage="currentPage"
            :pageSize="pageSize"
            @queryChange="queryChange"
          ></pagination-tpl>
        </div>
      </div>
      <div v-else class="nothing">
        <img class="nothing-img" src="~assets/images/nothing/nothing.png">
      </div>
    </div>

    <!-- 账单明细导出 -->
    <el-drawer
      class="export-details"
      title="账单明细导出"
      :visible.sync="drawer"
      :wrapperClosable="false"
      :before-close="handleCloseExportDetailsDrawer">
        <el-form ref="exportDetailsForm" :model="exportDetailsForm" :rules="exportDetailsRules">
          <el-form-item label="日期" prop="month">
            <el-date-picker
              v-model="exportDetailsForm.month"
              type="month"
              format="yyyy-MM"
              value-format="yyyy-MM"
              placeholder="请选择"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="仓库名称" prop="warehouseId">
            <el-select 
              class="white"
              clearable
              v-model="exportDetailsForm.warehouseId"
              placeholder="请选择"
            >
              <el-option
                v-for="item in warehouseList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="快递类型" prop="expressType">
            <el-select 
              class="white"
              clearable
              v-model="exportDetailsForm.expressType"
              placeholder="请选择"
            >
              <el-option
                v-for="item in expressList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      <div class="drawer-footer">
        <el-button class="btn-gray" @click="handleCloseExportDetailsDrawer">取消</el-button>
        <el-button class="btn-blue" @click="exportDetailsConfirm('exportDetailsForm')">确定</el-button>
      </div>
    </el-drawer>

    <!-- 导出提示 -->
    <el-dialog class="tips-dialog" title="提示" top="20vh" :visible.sync="tipsDialog" width="420px">
      <div>
        <i class="el-icon-warning"></i>
        <span class="tips">导出任务生成成功，共{{exportAllBillNums}}笔，请稍后前往[下载]！</span>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button class="btn-blue" @click="closeDialog">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import CarrierReconcliation from "models/carrier-reconcliation.js";
import logisticsBillMixins from '@/common/mixins/logistics-bill.js'
import warehouseMixins from "@/common/mixins/warehouse.js"
import expressMixins from "@/common/mixins/express.js"
export default {
  mixins: [logisticsBillMixins, warehouseMixins, expressMixins],

  data() {
    return {
      selectedTab: '月账单',
      search: {
        select: 2,
        date: "",
        month: "",
      },
      drawer: false,
      exportDetailsForm: {
        month: '',
        warehouseId: '',
        expressType: ''
      },
      exportDetailsRules: {
        month: [{ required: true, message: "请选择日期", trigger: "change" }],
        warehouseId: [{ required: true, message: "请选择仓库", trigger: "change" }],
        expressType: [{ required: true, message: "请选择快递类型", trigger: "change" }],
      },
      tipsDialog: false,
      exportAllBillNums: 0,
    }
  },
  
  activated() {
    this.selectedTab = '月账单'
    this.search.select = 2
  },

  created() {
    this.initWarehouse()
    this.initExpressList()
    this.initLogisticsBillList()
  },

  methods: {
    openExportDetailsExcel() {
      this.drawer = true
    },

    handleCloseExportDetailsDrawer() {
      this.exportDetailsForm.month = ''
      this.exportDetailsForm.warehouseId = ''
      this.exportDetailsForm.expressType = ''
      this.drawer = false
    },

    exportDetailsConfirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {
            date: this.exportDetailsForm.month,
            warehouseId: this.exportDetailsForm.warehouseId,
            expressType: this.exportDetailsForm.expressType
          }
          CarrierReconcliation.postExportMonthBill(data).then(res => {
            if (res.success) {
              this.handleCloseExportDetailsDrawer()
              this.exportAllBillNums = res.result
              this.tipsDialog = true
            } else {
              this.$message({
                type: 'error',
                message: res.message
              })
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    closeDialog() {
      this.tipsDialog = false
    },
  }
}
</script>

<style lang='scss'>
@import '@/assets/style/layout/operator/hr-bill.scss';
</style>